import { apiClient, Auth } from '@/shared/api'

import { TDepositReturnCard } from '../model/schema'

export const getGuestDepositReturnCard = async (contractId: number) => {
  const response = await apiClient.get<TDepositReturnCard>({
    endpoint: `/guest/contracts/${contractId}/deposit-return-card`,
    auth: Auth.REQUIRED,
  })

  return response
}
